<template>
  <g stroke="null" fill-rule="evenodd" fill="none">
    <path d="M.063.062h19.874v19.875H.063V.062z" />
    <path
      d="M10 1.72a4.969 4.969 0 014.969 4.968v.021a2.84 2.84 0 012.484 2.818v5.914c0 1.57-1.27 2.84-2.84 2.84H5.387a2.839 2.839 0 01-2.84-2.84V9.527A2.841 2.841 0 015.032 6.71v-.021A4.969 4.969 0 0110 1.719zm0 9.108a1.658 1.658 0 000 3.313 1.658 1.658 0 000-3.313zm0-7.454a3.313 3.313 0 00-3.305 3.087l-.007.227h6.624c0-1.83-1.48-3.314-3.312-3.314z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
